import { Component, Input, OnInit } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { BaseWithIdList } from '@app/shared/models/list';
import { SMPComment } from '@app/shared/models/comment';
import { CaseCommentsService, CaseCommentsUriBuilderParams } from '@app/core/services/case-comments.service';
import { ContentStoreService } from '@app/core/services/content-store.service';
import { DrFileMetaCategoryList } from '@app/shared/models/dr-file';
import { CaseFileCategory } from '@app/shared/models/case-file-category';
import { Role } from '@app/core/authentication/permission';
import { FileActions } from '@app/shared/models/file-actions';


@Component({
    selector: 'case-lawyer-readonly',
    templateUrl: './case-lawyer-readonly.component.html',
    styleUrls: ['./case-lawyer-readonly.component.scss']
})
export class CaseLawyerReadonlyComponent extends BaseWithBundleComponent
                                         implements OnInit {

    @Input()
    public caseId: string;

    public commentsList: BaseWithIdList<SMPComment>;

    public fileMetaCategoryList: DrFileMetaCategoryList;
    public accidentDocumentCategory = CaseFileCategory.ACCIDENT_DOCUMENT.key;

    public disabledOptions = [
        FileActions.DELETE
    ];

    get Role() {
        return Role;
    }

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected caseCommentsService: CaseCommentsService,
                protected contentStoreService: ContentStoreService) {
        super(componentServiceBundle);
    }

    public ngOnInit() {
        super.ngOnInit();

        this.contentStoreService.getCaseFileMetaList(this.caseId, [this.accidentDocumentCategory], Role.SMP_LAWYER)
            .subscribe((result: DrFileMetaCategoryList) => {
                    this.fileMetaCategoryList = result;
                }, err => this.handleError(err)
            );

        this.caseCommentsService.query(this.generateCaseCommentsUriBuilder())
            .subscribe(result => {
                this.commentsList = result;
                }, err => this.handleError(err)
            );
    }

    protected generateCaseCommentsUriBuilder(comment?: SMPComment): CaseCommentsUriBuilderParams {
        return new CaseCommentsUriBuilderParams(this.caseId, comment ? comment : null);
    }
}
